import { useEffect } from 'react';

interface SEOProps {
  schema?: object;
}

export function SEO({ schema }: SEOProps) {
  useEffect(() => {
    if (schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = 'schema-org';
      
      const existingScript = document.getElementById('schema-org');
      if (existingScript) {
        existingScript.remove();
      }
      
      document.head.appendChild(script);

      return () => {
        const scriptToRemove = document.getElementById('schema-org');
        if (scriptToRemove) {
          scriptToRemove.remove();
        }
      };
    }
  }, [schema]);

  return null;
}
